module.exports = __webpack_public_path__ + "img/file-earmark-font-fill.f9ffecc6.svg";